import { Component, OnInit } from '@angular/core';
import { initFlowbite } from 'flowbite';
import { RateListGeneratorService } from '../../../../Services/Rate_List_Generator/rate-list-generator.service';
import { NgFor } from '@angular/common';
import { NotificationService } from './../../../../Services/notification.service';
import { Router, RouterLink } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-generated-ratelist',
  standalone: true,
  imports: [NgFor, RouterLink, FormsModule],
  templateUrl: './generated-ratelist.component.html',
  styleUrl: './generated-ratelist.component.css'
})
export class GeneratedRatelistComponent implements OnInit {

  RateListGeneratorList: any[] = [];
  allRateList: any[] = [];

  // Filters
  selectedCustomerType: string = '';
  fromDate: string = '';
  toDate: string = '';
  // pagination
currentPage: number = 1;
pageSize: number = 10;
totalPages: number = 1;

paginatedRateList: any[] = [];
pages: number[] = [];

  constructor(
    private rateListGeneratorService: RateListGeneratorService,
    private NotificationService: NotificationService,
    private router: Router
  ) { }

  ngOnInit(): void {
    initFlowbite();
    this.getRateList();
  }

  getRateList() {
    let params = new HttpParams();
    this.rateListGeneratorService.getRateList(params).subscribe(
      (res: any) => {
        this.allRateList = res.data.reverse();
        this.RateListGeneratorList = [...this.allRateList];
        this.updatePagination();
      },
      (error: any) => { }
    );
  }
updatePagination() {

  this.totalPages = Math.ceil(this.RateListGeneratorList.length / this.pageSize);

  const start = (this.currentPage - 1) * this.pageSize;
  const end = start + this.pageSize;

  this.paginatedRateList = this.RateListGeneratorList.slice(start, end);

  this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);

}
changePage(page: number) {

  if (page < 1 || page > this.totalPages) return;

  this.currentPage = page;
  this.updatePagination();

}
  // ✅ Common filter method (Customer Type + Date)
  applyFilters() {

  this.RateListGeneratorList = this.allRateList.filter(rate => {

    const matchCustomer =
      !this.selectedCustomerType ||
      rate.rlg_customer_type === this.selectedCustomerType;

    const rateDate = new Date(rate.created_at);
    rateDate.setHours(0,0,0,0);

    let from = this.fromDate ? new Date(this.fromDate) : null;
    let to = this.toDate ? new Date(this.toDate) : null;

    if (from) from.setHours(0,0,0,0);
    if (to) to.setHours(23,59,59,999);

    const matchFrom = !from || rateDate >= from;
    const matchTo = !to || rateDate <= to;

    return matchCustomer && matchFrom && matchTo;

  });

  this.currentPage = 1;
  this.updatePagination();
}
clearFilters() {

  this.fromDate = '';
  this.toDate = '';
  this.selectedCustomerType = '';

  this.RateListGeneratorList = [...this.allRateList];
   this.currentPage = 1;
  this.updatePagination();

}
  onPrintinvoiceClick() {
    if (!this.RateListGeneratorList || this.RateListGeneratorList.length === 0) {
      this.NotificationService.showError('No rate lists available to print.', 'Error');
      return;
    }

    const ids = this.RateListGeneratorList.map((x: any) => x.rlg_id).join(',');
    this.openPrintView(ids);
  }

  openPrintView(ids: string) {
    this.router.navigate(['/rate-list/print', ids]);
  }

}